export default __webpack_public_path__ + "static/media/mockup-iphone-uruguay.7ff1f930.png";